import React from 'react'
import InfoMessage, {
  InfoMessageContent,
  InfoMessageTextLine,
} from '../InfoMessage'
import { ReactComponent as CommentsIcon } from '@sketch/icons/comments-64-svg'
import AddAnnotationButton from '../AddAnnotationButton'

interface CommentTabMessageNoAnnotationsProps {
  action?: React.ReactNode
  showAddCommentButton?: boolean
  permanentArtboardId?: string
  permanentPageId?: string
}

const getCommentableName = (isArtboard: boolean, isDocument: boolean) => {
  if (isArtboard) return 'Artboard'
  if (isDocument) return 'document'
  return 'page'
}

const CommentTabMessageNoAnnotations: React.FC<CommentTabMessageNoAnnotationsProps> = ({
  action,
  permanentArtboardId,
  permanentPageId,
  showAddCommentButton,
}) => {
  const isArtboard = Boolean(permanentArtboardId)
  const isDocument = !permanentPageId

  const commentableName = getCommentableName(isArtboard, isDocument)

  return (
    <InfoMessage
      title="No comments"
      action={action}
      icon={<CommentsIcon role="img" />}
    >
      <InfoMessageContent>
        <InfoMessageTextLine>
          {`Nobody has commented on this ${commentableName} yet.`}
        </InfoMessageTextLine>
        {showAddCommentButton && (
          <AddAnnotationButton>Add New Comment</AddAnnotationButton>
        )}
      </InfoMessageContent>
    </InfoMessage>
  )
}

export default CommentTabMessageNoAnnotations
